export default __webpack_public_path__ + "static/media/securos-surgical.48278f0a.jpg";